import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({ shops, categories }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Categorie')}
          name='company_document_category_id'
          optionFilterProp={'label'}
        >
          <Select placeholder={t('Categorie')}>
            {categories?.map((i) => (
              <Select.Option key={i.id} value={i.id}>
                {i.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Data pubblicazione')}
          name='publishing_date'
          disabled={true}
        >
          <DatePicker
            disabled={true}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            placeholder={t('Insegna')}
            showSearch
            optionFilterProp={'title'}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {shops &&
              shops.map((shop) => (
                <Select.Option key={shop.value} value={shop.value}>
                  {shop.title}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
